import axiosClient from '@/api/axiosClient'
import { ApiResponse } from '@/api/services/CustomerService'
import { getCurrentUser } from '@/db/indexedDB'
import { IRiskScore } from '@/types'

const RISK_SCORE_PAGE_SIZE = 10

export const RiskScoreService = {
  fetchRiskScores: async (params: {
    page: number
    modelName?: string
  }): Promise<ApiResponse<IRiskScore>> => {
    const user = await getCurrentUser()

    const requestParams: Record<string, any> = {
      page: params.page,
      limit: RISK_SCORE_PAGE_SIZE,
    }

    if (params.modelName) {
      requestParams.modelName = params.modelName.toLowerCase()
    }

    const response = await axiosClient.get(`/users/${user.id}/risk-scores`, {
      params: requestParams,
    })

    return response.data
  },
}
